import { render } from "./StarCitizenView.vue?vue&type=template&id=26622e7a&scoped=true"
const script = {}

import "./StarCitizenView.vue?vue&type=style&index=0&id=26622e7a&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26622e7a"]])

export default __exports__